'use strict';

var Marionette = require('backbone-marionette');
var Controller = require('./controller');
// var Wreqr = require('./wreqr');
var ShopsCollection = require('./collections/shops');

var ShopModule = Marionette.Module.extend({
    startWithParent: true,

    initialize: function(moduleName, app) {
        this.listenTo(app.vent, 'logged-in', function(){
            app.loadData(this.shops);
        }.bind(this));
    },

    onStart: function(options) {
        var app = this.app;

        this.shops = new ShopsCollection();

        var controller = this.controller = new Controller({
            app: app,
            module: this,
        });

        // this.wreqr = new Wreqr({
        //     app: app,
        //     module: this,
        // });

        app.addInitializer(function(){
            app.router.processAppRoutes(controller, controller.routes);
        }.bind(this));
    },
});

module.exports = ShopModule;